import React from "react";
var __jsx = React.createElement;
import { useEffect, useRef, useState } from "react";
import stl from "./DaysComponent.module.css";
import SingleDay from "./SingleDay";
import Loader from "@componentsShared/Loader/Loader";
import { useLang } from "@/common/Contexts/LanguageContext";
import { FULL_DAYS_LIMIT } from "@/pages/schedule/components/ReserveAppointment";
import { checkFeatureFlag } from "@/common/config/websiteConfig";
import { useTranslation } from "@i18n";
var APPOINTMENT_RESCHEDULE_AUTO_SELECT_FIRST_DAY = checkFeatureFlag("FF_APPOINTMENT_RESCHEDULE_AUTO_SELECT_FIRST_DAY");
var DaysComponent = function DaysComponent(_ref) {
  var myTimestamp = _ref.myTimestamp,
    availableDays = _ref.availableDays,
    selectDay = _ref.selectDay;
  var _useState = useState({}),
    active = _useState[0],
    setActive = _useState[1];
  var scrollContainerRef = useRef(null);
  var dayRefs = useRef([]); // Reference array for days
  var lang = useLang();
  var _useTranslation = useTranslation(),
    t = _useTranslation.t;

  // Activate the first available (not disabled) day on mount
  useEffect(function () {
    if ((availableDays === null || availableDays === void 0 ? void 0 : availableDays.length) > 0) {
      var days = myTimestamp === null || myTimestamp === void 0 ? void 0 : myTimestamp.nextNDays(FULL_DAYS_LIMIT, availableDays).days;
      var firstAvailableDay = days.find(function (day) {
        return day === null || day === void 0 ? void 0 : day.available;
      });
      if (firstAvailableDay) {
        var index = days.indexOf(firstAvailableDay);
        setActive({
          idx: index + 1,
          timestamp: firstAvailableDay.timestamp
        });
        selectDay(firstAvailableDay.timestamp);
      }
    }
  }, [availableDays, myTimestamp, selectDay]);

  // Update time when active changes
  useEffect(function () {
    if (active.timestamp) {
      selectDay(active.timestamp);
      // Scroll to the active day element
      if (active.idx && dayRefs.current[active.idx - 1]) {
        dayRefs.current[active.idx - 1].scrollIntoView({
          behavior: "smooth",
          inline: "center"
        });
      }
    }
  }, [active, selectDay]);
  var scroll = function scroll(direction) {
    if (scrollContainerRef.current) {
      var scrollAmount = direction === "left" ? -100 : 100;
      scrollContainerRef.current.scrollBy({
        left: scrollAmount,
        behavior: "smooth"
      });
    }
  };
  useEffect(function () {
    if (APPOINTMENT_RESCHEDULE_AUTO_SELECT_FIRST_DAY && availableDays !== null && availableDays !== void 0 && availableDays.length) {
      var _document$querySelect;
      (_document$querySelect = document.querySelector('[data-enabled="true"]')) === null || _document$querySelect === void 0 ? void 0 : _document$querySelect.click();
    }
  }, [availableDays === null || availableDays === void 0 ? void 0 : availableDays.length]);
  return /*#__PURE__*/React.createElement(React.Fragment, null, availableDays ? /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("div", {
    className: stl.container
  }, /*#__PURE__*/React.createElement("span", {
    className: stl.prvArr,
    onClick: function onClick() {
      return scroll("left");
    }
  }), /*#__PURE__*/React.createElement("div", {
    ref: scrollContainerRef,
    className: stl.scrollContainer
  }, myTimestamp === null || myTimestamp === void 0 ? void 0 : myTimestamp.nextNDays(FULL_DAYS_LIMIT, availableDays).days.map(function (day, idx) {
    var _day$day;
    return /*#__PURE__*/React.createElement("div", {
      key: idx,
      ref: function ref(el) {
        return dayRefs.current[idx] = el;
      } // Attach reference to each day
    }, /*#__PURE__*/React.createElement(SingleDay, {
      activate: function activate() {
        return setActive({
          idx: idx + 1,
          timestamp: day.timestamp
        });
      },
      day: day === null || day === void 0 ? void 0 : (_day$day = day.day) === null || _day$day === void 0 ? void 0 : _day$day.split("-")[2],
      dayName: lang === "ar" ? day === null || day === void 0 ? void 0 : day.dayNameAr : (day === null || day === void 0 ? void 0 : day.dayNameEn) || (day === null || day === void 0 ? void 0 : day.dayNameAr),
      isActive: active.idx === idx + 1,
      disabled: !(day !== null && day !== void 0 && day.available)
    }));
  })), /*#__PURE__*/React.createElement("span", {
    className: stl.nxtArr,
    onClick: function onClick() {
      return scroll("right");
    }
  }))) : /*#__PURE__*/React.createElement(Loader, null));
};
export default DaysComponent;